import { EntidadeBase } from 'hay-core-react';
import { ApiService } from 'hay-core-react';
class RouterboardModel extends EntidadeBase {
    constructor() { super('routerboard'); }
    async gerarScript(routerboard)    { return await ApiService.post('routerboard/gerarscript',    { routerboard }); }
    async executarScript(routerboard) { return await ApiService.post('routerboard/executarscript', { routerboard }); }
    async testarAcesso(routerboard)   { return await ApiService.post('routerboard/testaracesso',    { routerboard }); }
    async testarConexao(routerboard)  { return await ApiService.post('routerboard/testarconexao',  { routerboard }); }
    async testarSsh(routerboard)      { return await ApiService.post('routerboard/testarssh',      { routerboard }); }
    // Usado por confirmarEAtivarApi pra decidir se mostra o aviso de reinicio (ver comentario lá).
    async verificarDeviceModeAtivo(routerboard) { return await ApiService.post('routerboard/verificardevicemode', { routerboard }); }
    // `mensagem` substitui o texto padrão do loading global enquanto a chamada está pendente — a
    // requisição de ativar API fica bloqueada até o usuário apertar o botão MODE/RESET do
    // equipamento e ele reiniciar (ver Routerboard.ativarApi no backend), então o loading é o
    // único lugar onde dá pra avisar isso (um Dialog só depois da resposta chegaria tarde demais).
    async ativarApi(routerboard, mensagem) { return await ApiService.post('routerboard/ativarapi', { routerboard }, mensagem); }
    // Mesma razão do 3º argumento `mensagem` de ativarApi: a emissão do certificado Let's Encrypt
    // (challenge ACME + polling no RouterOS) leva algumas dezenas de segundos, então o loading
    // global é o único lugar pra avisar isso enquanto a requisição está pendente.
    async ativarSslLetsEncrypt(routerboard, mensagem) { return await ApiService.post('routerboard/ativarsslletsencrypt', { routerboard }, mensagem); }
}

const instance = new RouterboardModel();
export default instance;
